import { useState } from "react";
import { Asset } from "../models/asset";

function useAssetPeriodicReview() {
    const [periodicReviewSidebar, setPeriodicReviewSidebar] = useState(false);
    const [assetPeriodicReviews, setAssetPeriodicReview] = useState<Asset | null>(null);

    const handlePeriodicReviewSidebar = (asset: Asset) => {
        setPeriodicReviewSidebar(!periodicReviewSidebar);
        setAssetPeriodicReview(asset);
    };

    const handleClosePeriodicReviewSidebar = () => {
        setPeriodicReviewSidebar(false);
        setAssetPeriodicReview(null);
    };

    return { handlePeriodicReviewSidebar, handleClosePeriodicReviewSidebar, periodicReviewSidebar, assetPeriodicReviews };
}

export default useAssetPeriodicReview;